import {RastreamentoLogFilter} from "../../filters/rastreamento-log-filter";
import {PagedList} from "../../models/paged-list";
import {RastreamentoLog} from "../../models/rastreamento-log";

export const RASTREAMENTO_LOGS_CACHE_KEY = 'fleetgame:rastreamento-logs:last-search';
export const RASTREAMENTO_LOGS_CACHE_TTL_MS = 10 * 60 * 1000;

export interface RastreamentoLogsCacheEntry {
    filter: RastreamentoLogFilter;
    data: PagedList<RastreamentoLog>;
    expiresAt: number;
}

export function normalizeCpfInput(cpf?: string | null): string | null {
    if (!cpf?.trim()) return null;
    const digits = cpf.replace(/\D/g, '');
    return digits.length > 0 ? digits : null;
}

export function normalizePlacaInput(placa?: string | null): string | null {
    if (!placa?.trim()) return null;
    const normalized = placa.replace(/[^0-9a-zA-Z]/g, '').toUpperCase();
    return normalized.length > 0 ? normalized : null;
}

export function prepareLogSearchFilter(filter: RastreamentoLogFilter): RastreamentoLogFilter {
    return {
        ...filter,
        MotoristaCpf: normalizeCpfInput(filter.MotoristaCpf),
        Placa: normalizePlacaInput(filter.Placa),
        MotoristaNome: filter.MotoristaNome?.trim() || null,
    };
}

/** Identifica a busca executada (ignora paginação). */
export function logSearchFingerprint(filter: RastreamentoLogFilter): string {
    const prepared = prepareLogSearchFilter(filter);
    return [
        prepared.clientId ?? '',
        prepared.MotoristaCpf ?? '',
        prepared.MotoristaNome ?? '',
        prepared.Placa ?? '',
        prepared.InicioIntervalo?.toString() ?? '',
        prepared.FimIntervalo?.toString() ?? '',
        prepared.RpmMin ?? '',
        prepared.RpmMax ?? '',
    ].join('|');
}

export function loadRastreamentoLogsCache(): RastreamentoLogsCacheEntry | null {
    try {
        const raw = sessionStorage.getItem(RASTREAMENTO_LOGS_CACHE_KEY);
        if (!raw) return null;

        const cached = JSON.parse(raw) as RastreamentoLogsCacheEntry;
        if (cached.expiresAt <= Date.now()) {
            sessionStorage.removeItem(RASTREAMENTO_LOGS_CACHE_KEY);
            return null;
        }

        return cached;
    } catch {
        sessionStorage.removeItem(RASTREAMENTO_LOGS_CACHE_KEY);
        return null;
    }
}

export function saveRastreamentoLogsCache(
    filter: RastreamentoLogFilter,
    data: PagedList<RastreamentoLog>,
): void {
    sessionStorage.setItem(
        RASTREAMENTO_LOGS_CACHE_KEY,
        JSON.stringify({
            filter,
            data,
            expiresAt: Date.now() + RASTREAMENTO_LOGS_CACHE_TTL_MS,
        }),
    );
}
